module.exports = __webpack_public_path__ + "static/media/post-09.a6a35765.jpg";